import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import styles from '../../theme';
import Iframe from '../../components/Iframe/Iframe';
import { getDiscoverResultIframeUrl } from '../../constants';
import Media from 'react-media';

@inject('routing', 'authStore', 'uiState')
@observer
export default class ResultView extends Component {
  render() {
    const { authStore: { user, isImpersonator } } = this.props;
    const currentUser = isImpersonator || user;
    console.log('email', currentUser.email);
    return (
      <Media query={{ maxWidth: styles.mq.large }}>
        {matches =>
          currentUser.email && (
            <Iframe
              src="/discover/result/pdf"
              height={matches ? 'calc(100vh - 145px)' : '100%'}
            />
          )
        }
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/discover/ResultView.js